import React from 'react'

// eslint-disable-next-line import/prefer-default-export
export const ProductContext = React.createContext()
export const ProductFormContext = React.createContext()
